import { useEffect } from 'react';

export const useFAQInteractivity = () => {
  useEffect(() => {
    // Make FAQ items interactive
    const faqItems = document.querySelectorAll('.faq-item');
    
    // Function to handle FAQ item clicks
    const handleFaqClick = (event) => {
      // Get the FAQ item (which might be a parent of the clicked element)
      const item = event.target.closest('.faq-item');
      if (!item) return;
      
      // Toggle active class on the clicked item
      item.classList.toggle('active');
    };
    
    // Add a delegated click handler to the container
    const containers = document.querySelectorAll('.faq-section');
    containers.forEach(container => {
      container.addEventListener('click', handleFaqClick);
    });
    
    // Open the first FAQ item by default if none are open
    const hasActiveItems = document.querySelector('.faq-item.active');
    if (!hasActiveItems && faqItems.length > 0) {
      faqItems[0].classList.add('active');
    }
    
    // Cleanup event listeners on component unmount
    return () => {
      containers.forEach(container => {
        container.removeEventListener('click', handleFaqClick);
      });
    };
  }, []);
}; 